import { Link } from 'react-router-dom';
import { HERO_CONTENT } from '@/content/features';
import Button from '@/components/ui/Button';

/**
 * FeaturesHero Component
 * Hero section for the Features page with title, subtitle, CTAs, and disclaimer badge
 */
export default function FeaturesHero() {
  return (
    <section className="relative bg-gradient-to-b from-brand-secondary to-white dark:from-secondary-900 dark:to-secondary-950 pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Disclaimer Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white dark:bg-secondary-800 border-2 border-primary-500 rounded-full mb-6 shadow-soft">
            <span className="text-2xl" role="img" aria-label="Medical symbol">
              {HERO_CONTENT.badge.icon}
            </span>
            <span className="text-sm font-semibold text-primary-700 dark:text-primary-400">
              {HERO_CONTENT.badge.text}
            </span>
          </div>

          {/* Title */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-secondary-900 dark:text-secondary-50 mb-6 leading-tight">
            {HERO_CONTENT.title}
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-secondary-700 dark:text-secondary-300 mb-10 leading-relaxed max-w-3xl mx-auto">
            {HERO_CONTENT.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to={HERO_CONTENT.primaryCTA.href}>
              <Button variant="primary" size="lg" className="w-full sm:w-auto">
                {HERO_CONTENT.primaryCTA.text}
              </Button>
            </Link>
            <Link to={HERO_CONTENT.secondaryCTA.href}>
              <Button variant="outline" size="lg" className="w-full sm:w-auto">
                {HERO_CONTENT.secondaryCTA.text}
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Decorative gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white dark:to-secondary-950 pointer-events-none" />
    </section>
  );
}

